module.exports = "<svg viewBox=\"0 0 162 145.9\"><g fill=\"#1E1E1C\"><path d=\"M81 65.2l79.2-30.4c1.1-.4 1.8-1.4 1.8-2.6V13.7C162 6.1 155.9 0 148.3 0H13.7C6.1 0 0 6.1 0 13.7v18.2c0 1.1.7 2.1 1.8 2.6L81 65.2z\"></path><path d=\"M81 86.7L2 55.9c-1-.4-2 .3-2 1.4v74.9c0 7.6 6.1 13.7 13.7 13.7h134.6c7.6 0 13.7-6.1 13.7-13.7V57.7c0-1-1-1.7-2-1.4L81 86.7z\"></path></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/mail.svg
// module id = 235
// module chunks = 1